export default {
    meta: {
        title: '鱼你在一起-申请保护',
        url: '/fishtogether/storeassess',
        urlName: '鱼你店铺评估'
    }
};
